import { bootstrapApplication } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localeNl from '@angular/common/locales/nl';
import localeEn from '@angular/common/locales/en';
import { initializeSentry } from '@thiememeulenhoff/ng-sdk';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';
import { isLocalEnvironment } from './core/utils/is-local-environment';
import { releaseVersion } from './core/utils/release-version';

initializeSentry(
  'https://445859a16c7cf0f484c8e26624cc971c@o1127103.ingest.us.sentry.io/4511552272269312',
  {
    enabled: !isLocalEnvironment(),
    environment: environment.environment,
    release: releaseVersion(),
    replaysSessionSampleRate: 0,
  },
);

export const startOneGate = async () => {
  try {
    await bootstrapApplication(AppComponent, appConfig);

    import('@thiememeulenhoff/albert');
    registerLocaleData(localeNl, 'nl');
    registerLocaleData(localeEn, 'en');
  } catch (err) {
    console.error(err);
  }
};

startOneGate();
